import React from 'react';
import Style from "./discuss.module.scss";
import background from "../../asset/discussion.jpeg";

function Index(props) {
    const { label } = props;
    return (
        <div className={Style.discussnContainer}>
        <img className='rounded' src="/background/discussion.jpeg"   />
            <h4 className={Style.textLabel+ " sm black"}>{label}</h4>
        </div>
    );
}

export default Index;